import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const StripeBalanceWidget = () =>
  import('@modules/stripe/stripe-balance/components/stripe-balance-widget.vue');

export default [{
  name: '',
  path: '',
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      name: 'balanceWidget',
      path: '/subproperty/wallet/balance',
      component: StripeBalanceWidget,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
    },
  ],
}];
